module.exports = __webpack_public_path__ + "static/media/filterNew.defc2032.svg";